module.exports = __webpack_public_path__ + "img/sendgrid.b9fa0aac.jpg";